/* @flow */

import React, { Component } from 'react';
import { ConnectedRouter } from 'react-router-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import Header from './Header';
import Navigation from './Navigation';
import PageLoader from 'shared/components/PageLoader';
import ReduxToastr from 'react-redux-toastr';
import * as PagesActions from 'catalog/actions/pages';
import { getIsFetching, getError } from 'catalog/reducers/pages';
import { getDeploymentError } from 'catalog/reducers/deployments';
import { getTemplates } from 'catalog/reducers/catalog';
import { getPlatforms } from 'catalog/reducers/platforms';
import Pages from './Pages';
import Create from './Page/Create';
import Edit from './Page/Edit';
import Secure from './Page/Secure';
import Catalog from './Catalog';
import Deployments from './Deployments';
import Archives from './Archives';

type Props = {
  history: Object,
  isFetching: boolean,
  error?: Error,
  templates: Array<CatalogTemplate>,
  platforms: Array<CatalogPlatform>,
  fetchPages: () => void,
};

const styles = {
  container: {
    height: '85%',
  },
};

const mapStateToProps = state => ({
  isFetching: getIsFetching(state),
  error: getError(state) || getDeploymentError(state),
  templates: getTemplates(state),
  platforms: getPlatforms(state),
});

const UNCONFIGURED_PLATFORM_MESSAGE = `
  La plateforme n'est actuellement pas configurée. Veuillez spécifier au moins un template
  et une plateforme cible.
`;

class App extends Component {
  props: Props;

  componentDidMount() {
    this.props.fetchPages();
  }

  render() {
    const { history, isFetching, error, templates, platforms } = this.props;

    if (isFetching) {
      return <PageLoader />;
    }

    if (error) {
      return (
        <Message
          error
          header="Une erreur est survenue"
          content={
            error.message ||
              'Veuillez nous excuser pour les désagréments occasionnés'
          }
          icon="bomb"
        />
      );
    }

    if (templates.length === 0 || platforms.length === 0) {
      return (
        <Message
          header="Configuration"
          content={UNCONFIGURED_PLATFORM_MESSAGE}
          icon="warning"
        />
      );
    }

    return (
      <ConnectedRouter history={history}>
        <div style={styles.container}>
          <Header />
          <Navigation />
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/pages" />} />
            <Route exact path="/pages" component={Pages} />
            <Route path="/pages/new" component={Create} />
            <Route exact path="/pages/:id" component={Edit} />
            <Route path="/pages/:id/secure" component={Secure} />
            <Route exact path="/view" component={Catalog} />
            <Route path="/view/:id" component={Catalog} />
            <Route path="/deployments" component={Deployments} />
            <Route path="/archives" component={Archives} />
            <Route
              render={() => (
                <Message icon="help" header={`La page demandée n'existe pas`} />
              )}
            />
          </Switch>
          <ReduxToastr
            timeOut={2000}
            newestOnTop={false}
            preventDuplicates={true}
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
          />
        </div>
      </ConnectedRouter>
    );
  }
}

export default connect(mapStateToProps, {
  fetchPages: PagesActions.fetchPages,
})(App);



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/App.js